(function() {
  'use strict';

  if (window.BikeZoneCollectionAffirm) {
    return;
  }

  var retryTimer = null;
  var retryDelay = 250;
  var maxAttempts = 20;

  function refresh(attempt) {
    retryTimer = null;

    if (
      window.affirm &&
      window.affirm.ui &&
      typeof window.affirm.ui.refresh === 'function'
    ) {
      try {
        window.affirm.ui.refresh();
        return;
      } catch (error) {
        // The SDK can expose its API just before it is ready to render.
      }
    }

    if (attempt < maxAttempts - 1) {
      retryTimer = window.setTimeout(function() {
        refresh(attempt + 1);
      }, retryDelay);
    }
  }

  function requestRefresh() {
    if (retryTimer !== null) {
      window.clearTimeout(retryTimer);
    }

    refresh(0);
  }

  window.BikeZoneCollectionAffirm = {
    refresh: requestRefresh
  };

  document.addEventListener('collection:reloaded', requestRefresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestRefresh, { once: true });
  } else {
    requestRefresh();
  }
})();
